import { Injectable } from '@angular/core';
import { ResourceRef, ResourceStatus } from '@angular/core';
import { MetricState } from '../Types/metric-state.type';

@Injectable({
  providedIn: 'root',
})
export class ResourceStateService {
  valueOf<T>(resource: ResourceRef<T | undefined>): T | undefined {
    return resource.hasValue() ? resource.value() : undefined;
  }

  metricState(status: ResourceStatus, permitted = true): MetricState {
    if (!permitted) {
      return 'restricted';
    }

    if (status === 'error') {
      return 'error';
    }

    if (status === 'resolved' || status === 'local') {
      return 'ready';
    }

    if (status === 'idle') {
      return 'unavailable';
    }

    return 'loading';
  }

  isBusy(status: ResourceStatus): boolean {
    return status === 'loading' || status === 'reloading';
  }
}
